/* ---------- 4. add to calendar ---------- */

import { $$, EXTERNAL, enc, setAttrs } from '../lib/dom';
import type { EventContext } from '../lib/event-context';

interface CalendarEvent {
  title: string;
  start: Date;
  end: Date;
}

const stamp = (date: Date) => date.toISOString().replace(/[-:]|\.\d{3}/g, ''); // 20260503T193000Z
const icsEscape = (s: string) => s.replace(/[\\;,]/g, '\\$&'); // RFC 5545 TEXT: backslash, semicolon and comma

export const CALENDAR_LINKS: Record<string, (event: CalendarEvent) => Record<string, string>> = {
  'data-gcal': ({ title, start, end }) => ({
    ...EXTERNAL,
    href: `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${enc(title)}&dates=${stamp(start)}/${stamp(end)}`,
  }),
  'data-outlook': ({ title, start, end }) => ({
    ...EXTERNAL,
    href: `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&subject=${enc(title)}&startdt=${enc(start.toISOString())}&enddt=${enc(end.toISOString())}`,
  }),
  'data-apple': ({ title, start, end }) => ({
    download: `${title}.ics`,
    href: `data:text/calendar;charset=utf8,${enc(
      [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//APP//Event Calendar//EN',
        'BEGIN:VEVENT',
        `UID:${Date.now()}@theapp.global`,
        `DTSTAMP:${stamp(new Date())}`,
        `DTSTART:${stamp(start)}`,
        `DTEND:${stamp(end)}`,
        `SUMMARY:${icsEscape(title)}`,
        'END:VEVENT',
        'END:VCALENDAR',
      ].join('\r\n'),
    )}`,
  }),
};

export const addToCalendar = ({ title, start, end }: EventContext) => {
  if (!title || !start) return;
  const event: CalendarEvent = { title, start, end: end ?? new Date(+start + 2 * 3600e3) }; // no end → 2h
  Object.entries(CALENDAR_LINKS).forEach(([hook, build]) => {
    const nodes = $$(`[${hook}]`);
    if (nodes.length) {
      const props = build(event);
      nodes.forEach((node) => setAttrs(node, props));
    }
  });
};
